import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { FooterNewsletterComponent } from '../../../app/content/layout/components/general/footer/components/footer-newsletter/footer-newsletter.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<FooterNewsletterComponent> = {
  title: 'Organisms/Footer/Footer Newsletter',
  component: FooterNewsletterComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<FooterNewsletterComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-newsletter')).toBeTruthy();
  },
};
